import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { isMobile } from "react-device-detect"
import LayoutWithModal from "components/Layout/LayoutWithModal"
import CommonStepBar from "components/common/CommonStepBar"
import { modalSelector } from "components/Modal/ModalSelector"
import QRScanResult from "components/QRReader/QRScanResult"
import { qrActions } from "store/actions/QRAction"
import { AppState } from "store/store"
import GoBackButton from "components/Button/GoBackButton"
import { APP_URL } from "Const"
import { buildUrlWithParams } from "utils/BuildUrlWithParams"
import styles from "./Result.module.scss"

export interface Props {
  result: any
}
/**
 * Step2 車情報入力画面
 * スキャン・アップロードされた車検証情報を表示
 * または直接入力の場合、車情報の入力画面を表示
 * @param {any}} props - 未使用・削除予定
 */
const Result = (props: any) => {
  const [openModal, setOpenModal] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const couponCode = useSelector((state: AppState) => state.couponCode.couponCode)
  const cameraOff = useSelector((state: AppState) => state.cameraOff.cameraOff)
  const { isScan } = useSelector((state: AppState) => state.qr)
  const getPrevURL = () => {
    const toTopWidthCode = buildUrlWithParams(APP_URL.TOP, couponCode, cameraOff)
    if (isMobile) {
      return isScan ? APP_URL.USAGE : toTopWidthCode
    }
    return isScan ? APP_URL.UPLOAD : toTopWidthCode
  }
  const onSubmit = (
    valueVehicleType: string,
    valueCarModel: string,
    valueFirstInspectionYear: string,
    valueFirstInspectionMonth: string,
    valueCarName: string,
    valueAutomaticBraking: string,
    valeAebButtonSelected: string,
    valueIsScan: boolean,
    valuleAEBVisible: boolean
  ) => {
    dispatch(qrActions.updateVehicleType(valueVehicleType)) // 用途車種
    dispatch(qrActions.updateCarModel(valueCarModel)) // 型式
    dispatch(qrActions.updateFirstInspectionYear(valueFirstInspectionYear)) // 初度登録年
    dispatch(qrActions.updateFirstInspectionMonth(valueFirstInspectionMonth)) // 初度登録月
    dispatch(qrActions.updateCarName(valueCarName)) // 車名
    dispatch(qrActions.updateAutomaticBraking(valueAutomaticBraking)) // 自動ブレーキ
    dispatch(qrActions.updateAebButtonSelected(valeAebButtonSelected)) // 自動ブレーキ(あり/なし/わからない)のボタンが押されたかどうか
    dispatch(qrActions.updateIsScan(valueIsScan)) // スキャンフラグ
    dispatch(qrActions.updateIsAEBShown(valuleAEBVisible)) // AEB選択項目の表示・非表示フラグ
    navigate(APP_URL.CONDITIONS)
  }
  return (
    <LayoutWithModal
      openModal={openModal}
      closeModal={() => {
        setOpenModal(false)
      }}
      innerContents={modalSelector("confirmation")}
    >
      <CommonStepBar num={2} />
      <QRScanResult
        submit={onSubmit}
        openModal={() => {
          setOpenModal(true)
        }}
      />
      <GoBackButton where={getPrevURL()} />
    </LayoutWithModal>
  )
}

export default Result
